import React from "react";
import { FormGroup, Label, Input, FormFeedback } from "reactstrap";
import { useField } from "formik";

// App
import { DropdownProps } from "../../../../types";

const Dropdown: React.FC<DropdownProps> = ({
  name,
  label,
  options,
  style,
  onChange,
  isRequired,
  insertDefault = false,
  disabled = false,
}) => {
  const [field, meta] = useField(name);
  const { onChange: fieldOnChange, ...fieldProps } = field;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // Formik's onChange handler
    fieldOnChange(e);

    // Custom onChange, if provided
    if (onChange) {
      onChange(e);
    }
  };

  return (
    <FormGroup floating style={style}>
      <Input
        type="select"
        {...fieldProps}
        name={name}
        placeholder={label}
        onChange={handleChange}
        disabled={disabled}
        invalid={meta?.touched && !!meta?.error}
      >
        {insertDefault && (
          <option key="" value="">
            Select
          </option>
        )}
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </Input>
      <Label className="ml-1" for={name}>{isRequired ? `${label} *` : label}</Label>
      {meta?.touched && meta?.error && (
        <FormFeedback>{meta?.error}</FormFeedback>
      )}
    </FormGroup>
  );
};

export default Dropdown;
